import React from "react";

export default class TutorialContent1 extends React.Component {
    constructor( props ) {
        super(props);
        
    }

    render() {
        return (
            <div>
                <h3 className="bottom-modal__title">
                    Einführung
                </h3>

                <div className="rte-content">
                    <div dangerouslySetInnerHTML={{__html: this.props.currentState.obj.tutorial_fields.step1_text}}></div>
                </div>
            </div>
        );
    }

}
